var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-credits"},[_c('slow-fade',{attrs:{"appear":true}},[(_vm.isMounted)?_c('typewriter',{staticClass:"c-credits-content",attrs:{"message":_vm.Credits},on:{"complete":_vm.onTypewriterComplete}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }